import {
  WorkOutline,
  GroupOutlined,
  QueryStatsOutlined,
  KeyboardVoiceOutlined,
  Troubleshoot,
  AccountCircleOutlined
} from '@mui/icons-material';

// Function to get nav items with dynamic paths based on role and clientId
const getNavItems = (role, clientId) => [
  { icon: WorkOutline, label: 'Jobs', path: '/jobs' },
  { 
    icon: GroupOutlined, 
    label: 'Talent Pool', 
    path: role === 'client' ? `/talent-pool/${clientId}` : '/talent-pool', 
    roles: ["Admin", "client"] 
  },
  { icon: QueryStatsOutlined, label: 'Market Intel', path: '/market-intel', roles: ["Admin"] },
  { icon: KeyboardVoiceOutlined, label: 'Interview', path: '/interviewList' },
  { icon: Troubleshoot, label: 'Analytics', path: '/analytics' },
  { icon: AccountCircleOutlined, label: 'Account', path: '/account-view' }
];

// Default export for backward compatibility
const navItems = getNavItems();

export { getNavItems };
export default navItems;
